import { Component, OnInit } from '@angular/core';
import { DeployPriorityGradingsService } from '../../services/deploy-priority-gradings.service';
import { MessageService } from 'primeng';
import { Message } from '../../classes/Message';

@Component({
  selector: 'deploy-priority',
  templateUrl: './deploy-priority.component.html',
})
export class DeployPriorityComponent implements OnInit {
  public calculatingGradings: boolean = false;

  public calculatingSensitivityScores: boolean = false;

  constructor(
    private deployPriorityService: DeployPriorityGradingsService,
    private messageService: MessageService,
  ) {}

  ngOnInit() {}

  async recalculateAllGradings() {
    try {
      this.calculatingGradings = true;
      await this.deployPriorityService.recalculateAllGradings();
      this.messageService.add(Message.Success('Successfully recalculated priority grades'));
    } catch (e) {
      this.messageService.add(
        Message.Error('An error occurred whilst recalculating priority grades'),
      );
    } finally {
      this.calculatingGradings = false;
    }
  }

  async recalculateAllSensitivityScores() {
    try {
      this.calculatingSensitivityScores = true;
      await this.deployPriorityService.recalculateAllSensitivityScores();
      this.messageService.add(Message.Success('Successfully recalculated sensitivity scores'));
    } catch (e) {
      this.messageService.add(
        Message.Error('An error occurred whilst recalculating sensitivity scores'),
      );
    } finally {
      this.calculatingSensitivityScores = false;
    }
  }
}
